import { TEquipmentTypesSchema } from 'transfix-form/forms/CarrierFleetInformation/components/EquipmentTypesModal/schema/EquipmentTypesSchema'
import { Maybe } from 'types/FMSGraphqlTypes'
import { TEquipmentCapabilities } from '../types'

export const getEquipmentTypesDefaultValues = (
  equipmentCapabilities: Maybe<TEquipmentCapabilities>
): TEquipmentTypesSchema => {
  const { isDryVanCapable, isFlatbedCapable, isReeferCapable, powerUnitCount, trailerCount } =
    equipmentCapabilities || {}
  return {
    powerUnitCount: powerUnitCount || 0,
    trailerCount: trailerCount || 0,
    isDryVanCapable: isDryVanCapable || false,
    isFlatbedCapable: isFlatbedCapable || false,
    isReeferCapable: isReeferCapable || false,
  }
}
